import React from 'react'
import PropTypes from 'prop-types'

import { useListingDisplay } from '../../../../hooks/listing'

import { ListingStatusHead } from '../../../../components'

import styles from './LaunchPadBotHead.module.scss'

const LaunchPadBotHead = ({ id, handleClick }) => {
  const { color, isFetched, isErrored } = useListingDisplay()

  return (
    <button id={id} className={styles.button} onClick={handleClick}>
      <ListingStatusHead
        color={color || 'pink'}
        spin={!isFetched}
        fail={isErrored}
      />
    </button>
  )
}

LaunchPadBotHead.propTypes = {
  id: PropTypes.string,
  handleClick: PropTypes.func,
}

export default LaunchPadBotHead
